import { FormField } from '../../type';

export type FileField = Extract<FormField, { blockType: 'file' }>;

export const isFileField = (field: FormField): field is FileField =>
  field.blockType === 'file';
